import type { FC } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import CommentMessage from '../CommentMessage';

interface CommentMessageBlockquoteProps {
    message: string;
    metadata?: Record<string, unknown>;
    popupZIndex?: number;
}

const CommentMessageBlockquote: FC<CommentMessageBlockquoteProps> = ({ message, metadata, popupZIndex }) => {
    const { token } = useAntDesignTheme();

    return (
        <blockquote
            style={{
                background: token.colorFillQuaternary,
                border: `1px solid ${token.colorBorderSecondary}`,
                borderInlineStart: `3px solid ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                color: token.colorTextSecondary,
                lineHeight: 1.5,
                margin: 0,
                overflowWrap: 'anywhere',
                padding: '0.5rem 0.625rem',
            }}
        >
            <CommentMessage message={message} metadata={metadata} popupZIndex={popupZIndex} />
        </blockquote>
    );
};

export default CommentMessageBlockquote;
